import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { CircularProgress } from '@material-ui/core';

const blockStyles = makeStyles(theme => ({
  root: {
    display: "block",
    margin: "0px auto 70px",
    width: "100%"
  },
}));

const LoadingIndicator = (props) => {
  const classes = blockStyles();
  
  const { className } = props;
  return (
    <CircularProgress className = { clsx(classes.root, className) }/>
  );
};

export default LoadingIndicator;